function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($helpers, Object, hidden) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          hidden
        }, {
          'gdpr-banner-container': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'gdpr-banner-text': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(`Mixpanel uses cookies to make it easier for you to use our website; read more about our `);
          __jade_nodes = __jade_nodes.concat(h("a", {
            "attrs": {
              href: 'https://mixpanel.com/legal/privacy-policy'
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("cookie policy");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(`. We will also collect personal information about you as described in our `);
          __jade_nodes = __jade_nodes.concat(h("a", {
            "attrs": {
              href: 'https://mixpanel.com/legal/privacy-policy'
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat("privacy statement");;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(`. By using our services you agree to the use of cookies and to the collection of your personal information.`);;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("mp-button", {
          "attrs": {
            theme: `primary`
          },
          "on": {
            click: $helpers.onAccept
          },
          "class": {
            'gdpr-banner-accept': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat("I agree");;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("button", {
          "on": {
            click: $helpers.onDismiss
          },
          "class": {
            'gdpr-banner-dismiss': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("svg-icon", {
            "attrs": {
              icon: `x`
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "hidden" in locals ? locals.hidden : typeof hidden !== "undefined" ? hidden : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;